export const common = {
  // Navigation
  home: 'Home',
  dashboard: 'Dashboard',
  nutritionPlan: 'Nutrition Plan',
  recipes: 'Recipes',
  shoppingList: 'Shopping List',
  progress: 'Progress',
  profile: 'Profile',
  admin: 'Admin',
  productSettings: 'Product Settings',
  logout: 'Logout',
  
  // Common Actions
  save: 'Save',
  saving: 'Saving...',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  submit: 'Submit',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  view: 'View',
  details: 'Details',
  
  // Common Labels
  email: 'Email',
  password: 'Password',
  name: 'Name',
  age: 'Age',
  gender: 'Gender',
  height: 'Height',
  weight: 'Weight',
  goal: 'Goal',
  status: 'Status',
  date: 'Date',
  time: 'Time',
  select: 'Select',
  month: 'Month',
  year: 'Year',
  important: 'Important',
  
  // Status
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
  pending: 'Pending',
  
  // Messages
  loading: 'Loading...',
  noData: 'No data available',
  error: 'An error occurred',
  success: 'Success',
  
  // Units
  kg: 'kg',
  cm: 'cm',
  kcal: 'kcal',
  g: 'g',
  min: 'min',
  days: 'days',
  weeks: 'weeks',
  months: 'months',

  importantNote: 'Important Note',

  chatbot: {
    modifyNutritionPlan: "I want to modify my nutrition plan",
    createNutritionPlan: "I want to create my nutrition plan",
    changeMealsForDay: "I want to change my meals for day {{dayNumber}}",
    modifyPlanPreview: "Change day {{dayNumber}} {{mealType}} for the new {{planTitle}} plan"
  },
  retry: 'Retry',
  keyTakeaway: 'Key Takeaway',

  app: {
    title: "NutriBot - Your Personal Nutrition Coach"
  }
};
